import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomFilterTableChip } from 'src/app/models/custom-filters/custom-filter-table.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-custom-filter-chips',
    imports: [
        CommonModule,
        MatButtonModule,
        MatChipsModule,
        TranslateModule
    ],
    templateUrl: './custom-filter-chips.component.html',
    styleUrls: ['./custom-filter-chips.component.scss']
})
export class CustomFilterChipsComponent {
  private customChipsFilters: CustomFilterTableChip[] = [];
  showFilter: boolean;

  @Input() set setCustomChipFilter(customFilterChip: CustomFilterTableChip[]) {
    if (customFilterChip?.length > 0) {
      this.customChipsFilters = customFilterChip.slice().sort((a, b) => a.Order - b.Order);
    }
  }
  @Input() set setShowFilter(filter: boolean) {
    this.showFilter = filter;
    if (!filter) {
      this.onClearFilter();
    }
  }

  filterSelected: any;
  @Output() selectedCustomFilterChip = new EventEmitter();
  @Output() hiddenFilter = new EventEmitter();

  get getCustomChipFilters() { return this.customChipsFilters; }

  selectFilterChip(filter: any) {
    if (this.filterSelected === filter) {
      this.filterSelected = undefined;
    }
    else {
      this.filterSelected = filter;
    }
    this.selectedCustomFilterChip.emit(this.filterSelected);
  }

  onClearFilter() {
    this.filterSelected = undefined;
    this.selectedCustomFilterChip.emit(this.filterSelected);
  }

  onHiddenFilter() {
    this.hiddenFilter.emit();
  }

  returnClass(chipItem: CustomFilterTableChip) {
    return {
      [chipItem.Class ?? 'selected']: this.filterSelected === chipItem.Id
    };
  }
}
